module.exports = __webpack_public_path__ + "static/flyer-1d9ae8df3a6de06fa06f4475c056d2c5.pdf";